import { useEffect, useState } from "react";
import api, { resolveUrl } from "@/lib/api";
import Header from "@/components/sections/Header";
import DownloadSection from "@/components/sections/DownloadSection";
import ScreenshotsMarquee from "@/components/sections/ScreenshotsMarquee";
import MarketsSection from "@/components/sections/MarketsSection";
import HowToDownload from "@/components/sections/HowToDownload";
import GameRates from "@/components/sections/GameRates";
import Footer from "@/components/sections/Footer";

export default function Landing() {
  const [settings, setSettings] = useState(null);
  const [markets, setMarkets] = useState([]);
  const [rates, setRates] = useState([]);
  const [screenshots, setScreenshots] = useState([]);
  const [howto, setHowto] = useState([]);

  useEffect(() => {
    Promise.all([
      api.get("/settings"),
      api.get("/markets"),
      api.get("/rates"),
      api.get("/screenshots"),
      api.get("/howto"),
    ]).then(([s, m, r, sc, h]) => {
      setSettings(s.data);
      setMarkets(m.data);
      setRates(r.data);
      setScreenshots(sc.data);
      setHowto(h.data);
    });
  }, []);

  useEffect(() => {
    if (!settings) return;
    document.title = settings.app_name || "Royal Market";
    if (settings.logo_url) {
      const favicon = document.getElementById("dynamic-favicon");
      if (favicon) favicon.href = resolveUrl(settings.logo_url);
    }
  }, [settings]);

  if (!settings) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-dark">
        <div className="text-[#ffd700] font-bold text-2xl">Loading Royal Market…</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-dark" data-testid="landing-page">
      <Header settings={settings} />
      <DownloadSection settings={settings} />
      <ScreenshotsMarquee screenshots={screenshots} resolveUrl={resolveUrl} title="App Screenshots" subtitle="In-App Gallery" />
      <MarketsSection markets={markets} />
      <GameRates rates={rates} />
      <HowToDownload howto={howto} resolveUrl={resolveUrl} />
      <Footer />
    </div>
  );
}
